export default __webpack_public_path__ + "static/media/Images-04.96eaa85c.png";